// To ensure external settings are loaded, use the Initialized promise:
OneTrust.NoticeApi.Initialized.then(function () {
    OneTrust.NoticeApi.LoadNotices(["https://privacyportalde-cdn.onetrust.com/42d99e0c-4f88-4461-961d-837bee566fc9/privacy-notices/draft/14c1d91f-46c0-4d98-920f-ec8d41f3271e.json"], false);
    });
